module.exports = __webpack_public_path__ + "img/ic_redemption.273dacbe.png";